import React from "react";

// /document-api?i=credential-requirements
export default function CredentialRequirements() {
  return (
    <>
              <p>
                Before integrating with our API, clients are required to provide
                the following details in order to enable access:
              </p>
              <h5 className="fw-bold">1. Integration Email</h5>
              <p>
                The email address used for registration or the designated system
                administrator’s email (Integration Contact Email).
              </p>
              <ul>
                <li>
                  This email will be used for communication, sending
                  credentials, certification files, incident reporting, and
                  security notifications.
                </li>
                <li>
                  <b>Example:</b> dev-team@merchant.com
                </li>
              </ul>
              <h5 className="fw-bold">
                2. IP Address for Connection (Whitelist)
              </h5>
              <p>
                The public IP address(es) of the system that will connect to our
                API.
              </p>
              <ul>
                <li>
                  You may register more than one IP, up to a maximum of 10 IP
                  addresses.
                </li>
                <li>
                  These IPs will be whitelisted to enhance security and prevent
                  unauthorized connections.
                </li>
                <li>
                  <b>Example:</b> 203.150.xxx.xxx, 45.76.xxx.xxx{" "}
                </li>
              </ul>
              <div className="fw-bold mb-2">📝 Important Notes:</div>
              <p>
                If there are any changes to your IP address, please notify our
                Support Team in advance.
              </p>
              <h5 className="fw-bold">3. Callback URL (Webhook Endpoint)</h5>
              <p>
                The URL where your system expects to receive transaction results
                or status updates.
              </p>
              <ul>
                <li>
                  Must be <b>HTTPS</b> (TLS 1.2 or higher) for secure
                  communication.
                </li>
                <li>
                  Should be able to accept <b>POST requests in JSON format.</b>
                </li>
              </ul>
              <div className="fw-bold mb-2">📝 Security Notes:</div>
              <ul>
                <li>
                  Only use <b>HTTPS</b> for your endpoint.
                </li>
                <li>Avoid exposing unencrypted or insecure endpoints.</li>
              </ul>
    </>
  );
}
